import './index.scss'
// import '../../assets/scripts/myNiceScroll'
// import {resizeScroll} from '../../assets/scripts/myNiceScroll'

$(document).ready(function(){
  if($(window).width() > 1024){
    let len = $('.section1 .sec1-nav ul li').length + 1
    let html = ''
    for(let i = 0; i < len ; i++){
      html += `<div class="zw"></div>`
    }
    $('.section1').append(html)
  }
})

let scrollLeft = 0

$(document).scroll(function () {
  let scroH = $(document).scrollTop(); //滚动高度
  let viewH = $(window).height(); //可见高度
  let sec1Top = $('.section1').offset().top
  let sec1Btm = $('.section1').offset().top + $('.section1').outerHeight()
  if($(window).width() > 1024){
    
    if(scroH > sec1Top && scroH < sec1Btm){
      $('header').fadeOut()
    }else{
      $('header').fadeIn()
    }
    if(scroH > sec1Top && scroH < sec1Btm - viewH){
      $('.section1 .fixed-cont').addClass('fixed').removeClass('abs')
    }else if( scroH >= sec1Btm - viewH){
      $('.section1 .fixed-cont').removeClass('fixed').addClass('abs')
    }else{
      $('.section1 .fixed-cont').removeClass('fixed').removeClass('abs')
    }

    let navH = $('.section1 .sec1-nav').outerHeight()
    let cont1Top = $('.section1 .zw').eq(0).length > 0 ? $('.section1 .zw').eq(0).offset().top : viewH
    let cont2Top = $('.section1 .zw').eq(1).length > 0 ? $('.section1 .zw').eq(1).offset().top : viewH
    let cont3Top = $('.section1 .zw').eq(2).length > 0 ? $('.section1 .zw').eq(2).offset().top : viewH
    let cont4Top = $('.section1 .zw').eq(3).length > 0 ? $('.section1 .zw').eq(3).offset().top : viewH
    let cont5Top = $('.section1 .zw').eq(4).length > 0 ? $('.section1 .zw').eq(4).offset().top : viewH

    //标题对应
    if(scroH < cont2Top + viewH/2){
      $('.section1 .sec1-nav ul li').eq(0).addClass('active').siblings().removeClass('active')
      $('.section1 .sec1-nav').scrollLeft(0)
    }else if(scroH >= cont2Top + viewH/2 && scroH < cont3Top + viewH/2){
      $('.section1 .sec1-nav ul li').eq(1).addClass('active').siblings().removeClass('active')
      $('.section1 .sec1-nav').scrollLeft(160)
    }else if(scroH >= cont3Top + viewH/2 && scroH < cont4Top + viewH/2){
      $('.section1 .sec1-nav ul li').eq(2).addClass('active').siblings().removeClass('active')
      $('.section1 .sec1-nav').scrollLeft(160*2)
    }else if(scroH >= cont4Top + viewH/2 && scroH < cont5Top + viewH/2){
      $('.section1 .sec1-nav ul li').eq(3).addClass('active').siblings().removeClass('active')
      $('.section1 .sec1-nav').scrollLeft(160*3)
    }else if(scroH >= cont5Top + viewH/2){
      $('.section1 .sec1-nav ul li').eq(4).addClass('active').siblings().removeClass('active')
      $('.section1 .sec1-nav').scrollLeft(160*4)
    }
    

    // translateY
    let transet = $(window).width() >= 768 ? 10 : 5
    if(scroH > cont2Top){
      let tran = (scroH - cont2Top) < (viewH - navH - transet) ? (scroH - cont2Top) : (viewH - navH - transet)
      $('.section1 .sec1-list li').eq(1).css('transform','translateY('+ -tran +'px)')
    }else{
      $('.section1 .sec1-list li').eq(1).css('transform','translateY(0px)')
    }
    if(scroH > cont3Top){
      let tran = (scroH - cont3Top) < (viewH - navH - transet*2) ? (scroH - cont3Top) : (viewH - navH - transet*2)
      $('.section1 .sec1-list li').eq(2).css('transform','translateY('+ -tran +'px)')
    }else{
      $('.section1 .sec1-list li').eq(2).css('transform','translateY(0px)')
    }
    if(scroH > cont4Top){
      let tran = (scroH - cont4Top) < (viewH - navH - transet*3) ? (scroH - cont4Top) : (viewH - navH - transet*3)
      $('.section1 .sec1-list li').eq(3).css('transform','translateY('+ -tran +'px)')
    }else{
      $('.section1 .sec1-list li').eq(3).css('transform','translateY(0px)')
    }
    if(scroH > cont5Top){
      let tran = (scroH - cont5Top) < (viewH - navH - transet*4) ? (scroH - cont5Top) : (viewH - navH - transet*4)
      $('.section1 .sec1-list li').eq(4).css('transform','translateY('+ -tran +'px)')
    }else{
      $('.section1 .sec1-list li').eq(4).css('transform','translateY(0px)')
    }

    // scale
    if(scroH > cont1Top + viewH/2){
      let scale = (1 - (scroH - cont1Top - viewH/2) / 5000) > 0.8 ? (1 - (scroH - cont1Top - viewH/2) / 5000) : 0.8
      $('.section1 .sec1-list li').eq(0).find('.c').css('transform','scale('+ scale +')')
    }else{
      $('.section1 .sec1-list li').eq(0).find('.c').css('transform','scale(1)')
    }
    if(scroH > cont2Top + viewH){
      let scale = (1 - (scroH - cont2Top - viewH) / 5000) > 0.85 ? (1 - (scroH - cont2Top - viewH) / 5000) : 0.85
      $('.section1 .sec1-list li').eq(1).find('.c').css('transform','scale('+ scale +')')
    }else{
      $('.section1 .sec1-list li').eq(1).find('.c').css('transform','scale(1)')
    }
    if(scroH > cont3Top + viewH){
      let scale = (1 - (scroH - cont3Top - viewH) / 5000) > 0.9 ? (1 - (scroH - cont3Top - viewH) / 5000) : 0.9
      $('.section1 .sec1-list li').eq(2).find('.c').css('transform','scale('+ scale +')')
    }else{
      $('.section1 .sec1-list li').eq(2).find('.c').css('transform','scale(1)')
    }
    if(scroH > cont4Top + viewH){
      let scale = (1 - (scroH - cont4Top - viewH) / 5000) > 0.95 ? (1 - (scroH - cont4Top - viewH) / 5000) : 0.95
      $('.section1 .sec1-list li').eq(3).find('.c').css('transform','scale('+ scale +')')
    }else{
      $('.section1 .sec1-list li').eq(3).find('.c').css('transform','scale(1)')
    }

    // opacity
    if(scroH > cont2Top + viewH){
      let opacity = (1 - (scroH - cont2Top - viewH) / 1000) > 0.2 ? (1 - (scroH - cont2Top - viewH) / 1000) : 0.2
      $('.section1 .sec1-list li').eq(0).css('opacity', opacity )
    }else{
      $('.section1 .sec1-list li').eq(0).css('opacity','1')
    }
    if(scroH > cont3Top + viewH){
      let opacity = (1 - (scroH - cont3Top - viewH) / 1000) > 0.4 ? (1 - (scroH - cont3Top - viewH) / 1000) : 0.4
      $('.section1 .sec1-list li').eq(1).css('opacity', opacity )
    }else{
      $('.section1 .sec1-list li').eq(1).css('opacity','1')
    }
    if(scroH > cont4Top + viewH){
      let opacity = (1 - (scroH - cont4Top - viewH) / 1000) > 0.6 ? (1 - (scroH - cont4Top - viewH) / 1000) : 0.6
      $('.section1 .sec1-list li').eq(2).css('opacity', opacity )
    }else{
      $('.section1 .sec1-list li').eq(2).css('opacity','1')
    }
    if(scroH > cont5Top + viewH){
      let opacity = (1 - (scroH - cont5Top - viewH) / 1000) > 0.8 ? (1 - (scroH - cont5Top - viewH) / 1000) : 0.8
      $('.section1 .sec1-list li').eq(3).css('opacity', opacity )
    }else{
      $('.section1 .sec1-list li').eq(3).css('opacity','1')
    }

  }
});

$('.section1 .sec1-nav ul').on('click','li',function(){
  let viewH = $(window).height();
  let index = $(this).index()
  let scrollTop = $('.section1 .zw').eq(index).offset().top + viewH
  $("html, body").animate({
    scrollTop: scrollTop
  }, {
      duration: 1000,
      easing: "swing"
  });
  return false;
})

